import { DigineticaIntegration } from '@app/components/shared/DigineticaIntegration';
import { useAppSelector } from '@redux/hooks';
import { FooterBlocks } from './FooterBlocks';
import { FooterDown } from './FooterDown';

import styles from './Footer.module.scss';

const FooterDesktop = (): JSX.Element => {
  const { shortHeader } = useAppSelector(state => state.header.data);
  return (
    <footer className={styles.Wrapper} data-testid="footer">
      <div className={styles.Container}>
        {!shortHeader && <FooterBlocks />}
        <FooterDown shortFooter={shortHeader} />
      </div>

      <DigineticaIntegration />
      <div data-popmechanic-embed="101671"></div>
    </footer>
  );
};

export default FooterDesktop;
